import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModalComponent {
  @Input() public isOpen: boolean = false;
  @Input() public title: string;
  @Input() public description: string;
  @Input() public descriptionParams?: {};
  @Input() public acceptText?: string;
  @Input() public declineText?: string;
  @Input() public acceptDisabled: boolean;
  @Input() public isAcceptLoading: boolean;

  @Output() public accept: EventEmitter<void> = new EventEmitter<void>();
  @Output() public decline: EventEmitter<void> = new EventEmitter<void>();

  public onBackdropClick(): void {
    this.decline.emit();
  }

  @HostListener('document:keydown.escape', ['$event'])
  public onEsc(event: KeyboardEvent): void {
    if (!this.isOpen || this.isAcceptLoading) {
      return;
    }
    event.preventDefault();
    this.decline.emit();
  }
}
